import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17 8h1a4 4 0 1 1 0 8h-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "2", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "2", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "14", y1: "2", y2: "4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Coffee";
const Coffee = memo(themed(Icon));
export {
  Coffee
};
//# sourceMappingURL=coffee.js.map
